/* @flow weak */
import PropTypes from 'prop-types';
import * as React from 'react';
import cx from 'classnames';
import Image from 'components/Image.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';
import { AvatarImages } from 'constants/AvatarConstants.js';

import './styles/JoinAvatarPanel.scss';

class JoinOrganizationAvatarPanel extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    organization: PropTypes.instanceOf(OrganizationProfile).isRequired,
    title: PropTypes.string,
    /* show the school name below the title, default true */
    showSchoolNameAboveAvatar: PropTypes.bool,
    /* show the school name above the address, default false */
    showSchoolNameAboveAddress: PropTypes.bool,
    /* faded theme (greyed) */
    faded: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    showSchoolNameAboveAvatar: true,
    showSchoolNameAboveAddress: false,
  };

  getSchoolImage = () => {
    // TODO return school image (not in entity ATM).
    return AvatarImages.ORG_AVATAR;
  };

  render() {
    const title = this.props.title ? this.props.title : 'Sign up for Remind at';
    let name = null;

    if (this.props.showSchoolNameAboveAvatar) {
      name = (
        <h4>
          <strong>{this.props.organization.getName()}</strong>
        </h4>
      );
    }

    let schoolName = null;
    if (this.props.showSchoolNameAboveAddress) {
      schoolName = (
        <span>
          <strong>{this.props.organization.getName()}</strong>
        </span>
      );
    }

    return (
      <div
        className={cx('JoinAvatarPanel', this.props.className, {
          'JoinAvatarPanel-Faded': this.props.faded,
        })}>
        <div className="JoinAvatarPanel-Header">
          <h4>{title}</h4>
          {name}
        </div>

        <Image className="JoinAvatarPanel-Image" src={this.getSchoolImage()} />

        <div className="JoinAvatarPanel-Footer">
          {schoolName}
          <br />

          {this.props.organization.getStreet() ? (
            <span>
              {this.props.organization.getStreet()}
              <br />
            </span>
          ) : null}
          <span>
            {this.props.organization.getCity()}
            {', '}
            {this.props.organization.getState()} {this.props.organization.getZip()}
          </span>
        </div>
      </div>
    );
  }
}

export default JoinOrganizationAvatarPanel;
